// extracted by mini-css-extract-plugin
export default {"sbp-logo":"styles_sbp-logo__06CC0","title":"styles_title__rcNA0","text":"styles_text__Eyu7C","link":"styles_link__aObpd"};